import React from 'react';
import { PropTypes } from 'prop-types';
import { flowRight as compose } from 'lodash';
import { graphql } from '@apollo/client/react/hoc';
import { withRouter } from 'next/router';
import {
  MUTATION_SEND_FORGOT_PASSWORD_EMAIL,
  MUTATION_DEACTIVATE_MEMBER,
  MUTATION_REMOVE_MEMBER
} from './NavCustomerMemberEditModal.gql';
import { withToastContext } from '../../../../../hocs';
import NavCustomerMemberEditModal from './NavCustomerMemberEditModal.component';

function NavCustomerMemberEditModalContainer(props) {
  const {
    member,
    organizationId,
    router,
    createToast,
    refetch,
    sendForgotPasswordEmail,
    deactivateMember,
    removeMember
  } = props;

  return (
    <NavCustomerMemberEditModal
      member={member}
      organizationId={organizationId}
      createToast={createToast}
      router={router}
      refetch={refetch}
      sendForgotPasswordEmail={sendForgotPasswordEmail}
      deactivateMember={deactivateMember}
      removeMember={removeMember}
    />
  );
}

NavCustomerMemberEditModalContainer.propTypes = {
  member: PropTypes.shape({ firstName: PropTypes.string, lastName: PropTypes.string, email: PropTypes.string })
    .isRequired,
  organizationId: PropTypes.number.isRequired,
  createToast: PropTypes.func.isRequired,
  router: PropTypes.shape({}).isRequired,
  refetch: PropTypes.func.isRequired,
  sendForgotPasswordEmail: PropTypes.func.isRequired,
  deactivateMember: PropTypes.func.isRequired,
  removeMember: PropTypes.func.isRequired
};

export default compose(
  withRouter,
  withToastContext(),
  graphql(MUTATION_SEND_FORGOT_PASSWORD_EMAIL, { name: 'sendForgotPasswordEmail' }),
  graphql(MUTATION_DEACTIVATE_MEMBER, { name: 'deactivateMember' }),
  graphql(MUTATION_REMOVE_MEMBER, { name: 'removeMember' })
)(NavCustomerMemberEditModalContainer);
